import { VestigingFormContext } from "../../../../Vestigingen/VestigingForm";
import { useFormContext } from "react-hook-form";
import { Button } from "@mui/material";
import React from "react";

export function InitializeArrangementVariant() {
  const { setValue }: VestigingFormContext = useFormContext();

  return (
    <>
      <h4>What arrangement variant do you want to create?</h4>
      <div style={{ display: "grid", gridTemplateColumns: "max-content 1fr", gap: "16px", alignItems: "center" }}>
        <Button
          onClick={() => setValue("variant", "regular", { shouldDirty: true })}
          style={{ height: "40px" }}
          variant={"contained"}
        >
          Regular
        </Button>
        <p style={{ margin: 0 }}>
          A regular arrangement is the "primary" arrangement for a given table. This is where you configure the rules
          for your arrangement.
        </p>
        <Button
          onClick={() => setValue("variant", "supplementary", { shouldDirty: true })}
          style={{ height: "40px" }}
          variant={"contained"}
        >
          Supplementary
        </Button>
        <p style={{ margin: 0 }}>
          A supplementary arrangement that can be loaded as a +1 to a regular arrangement on a table, for example "kids
          arrangement", "birthday arrangement", "baby arrangement". These arrangements have no rules of their own.
          <br />
          it is possible to attach extra menus if so desired.
        </p>
        <Button
          onClick={() => setValue("variant", "pre-dining", { shouldDirty: true })}
          style={{ height: "40px" }}
          variant={"contained"}
        >
          Pre-dining
        </Button>
        <p style={{ margin: 0 }}>
          A pre-dining arrangement can be attached to a table, zone and/or salesarea, all the products and menus will be
          made available to the customers <i>before a regular arrangement is placed on the table</i>.
          <br />
          This is intended for primarily for providing drinks to customers if they have to wait for an arrangement to be
          loaded onto their table.
        </p>
      </div>
    </>
  );
}
